module.exports = __webpack_public_path__ + "img/744.4d5dfe1f.jpg";